export const countEmojis = (text: string): number => {
  const matches = text.matchAll(/\p{Extended_Pictographic}/gu)
  return Array.from(matches).length
}
